export const ESIGN_ATTRIBUTES = {
    FIELD_ID: 'data-esign-field-id',
    FIELD_TYPE: 'data-esign-field-type',
    SIGNER_ID: 'data-esign-id',
    SIGNER_TYPE: 'data-esign-h',
    IS_OPTIONAL: 'data-esign-optional',
    TEXT_ALIGN_X: 'data-esign-text-align-x',
    TEXT_VALIDATION: 'data-esign-validation',
    TEXT_LINE_COUNT: 'data-esign-text-multiline',
    TEXT_FONT_SIZE: 'data-esign-text-font-size',
    TEXT_LENGTH_LINE: 'data-esign-text-length',
};